module.exports = __webpack_public_path__ + "static/media/297767.7d6a3718.png";